module.exports = __webpack_public_path__ + "fonts/Mukta-800-latin21.bdabc4f.woff2";